import { CommentState } from './comment-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import {
  Action,
  updateResourceByParam,
  setStateDirtyByParam,
} from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState: CommentState = {
  commentsById: {},
  commentsStateByJobApplicantId: {},
  commentsStateByEmployeeId: {},
};

const getParamsForContext = (context: CommentContext) => {
  const profileType = Object.keys(context)[0] as keyof CommentContext;
  const id = String(context[profileType]);
  return { profileType, id };
};

export const commentsReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_COMMENTS'): {
      const { context } = action.payload.args;
      const { profileType, id } = getParamsForContext(context);
      return updateResourceByParam(state, 'comments', profileType, id, true);
    }
    case SUCCESS('LOAD_COMMENTS'): {
      const {
        args: { context },
        data,
      } = action.payload;
      const { profileType, id } = getParamsForContext(context);
      const commentMap = convertArrayToMap(data, (comment: Comment) => String(comment.commentId));
      return updateResourceByParam(state, 'comments', profileType, id, false, commentMap);
    }
    case FAILURE('LOAD_COMMENTS'): {
      const { context } = action.payload.args;
      const { profileType, id } = getParamsForContext(context);
      return updateResourceByParam(state, 'comments', profileType, id, false);
    }
    case SUCCESS('SAVE_COMMENT'): {
      const { context } = action.payload.args;
      const { profileType, id } = getParamsForContext(context);
      return setStateDirtyByParam(state, 'comments', profileType, id);
    }
    case SUCCESS('DELETE_COMMENT'): {
      const { commentId } = action.payload.args;
      const newCommentsById = { ...state.commentsById };
      delete newCommentsById[commentId];
      state.commentsById = newCommentsById;
      return state;
    }
    case STARTING('EDIT_COMMENT'): {
      const { context } = action.payload.args;
      const { profileType, id } = getParamsForContext(context);
      return updateResourceByParam(state, 'comments', profileType, id, true);
    }
    case SUCCESS('EDIT_COMMENT'): {
      const {
        args: { commentId, context },
        data: { comment },
      } = action.payload;
      const { profileType, id } = getParamsForContext(context);
      return updateResourceByParam(state, 'comments', profileType, id, false, {
        [commentId]: comment,
      });
    }
    case FAILURE('EDIT_COMMENT'): {
      const { context } = action.payload.args;
      const { profileType, id } = getParamsForContext(context);
      return updateResourceByParam(state, 'comments', profileType, id, false);
    }
    case 'SET_COMMENT_DIRTY': {
      const { context } = action.payload.args;
      const { profileType, id } = getParamsForContext(context);
      return setStateDirtyByParam(state, 'comments', profileType, id);
    }
    default:
      return state;
  }
};
